

















































import MainLayout from '@/layouts/default/MainLayout.vue'
import HeaderLayout from '@/components/Header.vue'
import FooterLayout from '@/components/Footer.vue'
import toBgClClass from '@/filters/to-bg-cl-class'
import {Drawer} from 'element-ui'
import {Component, Vue, Prop, Watch} from 'vue-property-decorator'

@Component({
  components: {
    MainLayout,
    HeaderLayout,
    FooterLayout,
    [Drawer.name]: Drawer,
  },
  methods: {
    toBgClClass
  }
})

/**
 * 팝업 실행을 위한 공통 컴포넌트 PagePopup
 */
export default class PagePopup extends Vue {
  /**
   * 팝업 실행, 취소를 위한 prop
   */
  @Prop({default: false}) isVisible: boolean
  /**
   * * 팝업 header를 보여줄지 여부 prop
   */
  @Prop({default: true}) showHeader: boolean
  /**
   * 이전 팝업으로 갈 경우에 필요한 prop
   */
  @Prop({default: false}) backwards: boolean

  /**
   * 어떤 팝업인지 지정해주는 역할 prop
   */
  @Prop({default: ''}) popupName: string

  /**
   * 팝업 애니메이션 방향 지정 prop
   */
  @Prop({default: 'btt'}) direction: string
  /**
   * 팝업 사이즈 지정 prop
   */
  @Prop({default: '100%'}) size: string
  /**
   * 팝업 헤더 텍스트 prop
   */
  @Prop({default: ''}) headerText: string
  /**
   * 팝업 및 헤더 백그라운드 색상 적용을 위한 prop
   */
  @Prop({default: 'white'}) bgColor: string
  /**
   * 팝업 오른쪽 상단 닫기 버튼 유무 prop
   */
  @Prop({default: true}) showClose: boolean

  /**
   * 팝업 헤더 하단 border 유무
   */
  @Prop({default: true}) visibleHeaderBorder: boolean

  open: boolean = false
  back: boolean = false
  isBorder: boolean = false

  /**
   * isVisible 값 판별 후 팝업 실행, 취소
   */
  @Watch('isVisible', {immediate: true})
  __open(isVisible) {
    this.open = isVisible
  }

  onClose() {
    /**
     * 팝업이 꺼지는 경우 무조건 실행하는 emit: @on-after-close
     * this.back 의 boolean 값으로 위치 판별 (초기화 필요)
     */
    if(this.back) {
      this.back = false
      return
    }
    this.$emit('on-after-close')
    this.back = false
  }

  onBackwards(value: boolean) {
    /**
     * 이전 팝업 실행을 위한 emit: @on-backwards
     * this.back 의 boolean 값으로 판별
     */
    this.back = true
    this.$emit('on-backwards', value)
  }

  onScroll(value) {
    const {scrollTop} = value || {}
    this.isBorder = scrollTop > 0
  }
}
